<template>
  <div class="o-vote c-vote__list-item" v-on:click="pushVote"
    v-bind:class="{'o-vote--disabled': isDisabled}">
    <div class="o-vote__cover">
      <img :src="imageUrl" class="o-vote__img" alt="">
      <div class="o-vote__content">
        <h3 class="o-vote__title">{{track.title}}</h3>
        <p class="o-vote__artist">{{track.artist}}</p>
        <div class="o-progressbar">
          <div class="o-progressbar__track" v-bind:style="{width: track.score.percentage + '%'}"></div>
        </div>
      </div>
    </div>
    <div class="o-vote__actions">
      <button v-if="hasWinner && trackIndex === mgp.wonIndex" class="o-vote__button [ c-button
        c-button--secondary c-button--disabled ]">
          <SvgIcon aria-hidden="true" class="o-vote__icon" icon="music" />
        Gewonnen
      </button>
      <button v-else-if="hasWinner && trackIndex !== mgp.wonIndex" class="o-vote__button [ c-button c-button--secondary ]">
        Stem
      </button>
      <button v-else-if="mgp.allowVote || (hasVoted && trackIndex !== mgp.vote)" class="o-vote__button [ c-button c-button--secondary ]">
        Stem
      </button>
      <button v-else-if="hasVoted && trackIndex === mgp.vote" class="o-vote__button [ c-button c-button--secondary ]">
        <SvgIcon aria-hidden="true" class="o-vote__icon" icon="check" /> Gestemd
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'VoteTrack',
  props: [
    'track',
    'trackIndex',
    'hasWinner',
  ],
  computed: {
    ...mapState({
      hasVoted: state => state.mgp.vote !== false,
      mgp: state => state.mgp
    }),
    isDisabled() {
      if (this.hasWinner) {
        return this.trackIndex !== this.mgp.wonIndex;
      }
      return this.hasVoted && this.trackIndex !== this.mgp.vote;
    },
    imageUrl(){
      const { image_hash } = this.track;
      if (image_hash === '' || image_hash === null) {
        return 'https://static.qmusic.be/maximum_hits/cover-placeholder.png';
      }
      return `https://cdn-radio.dpgmedia.net${image_hash}`;
    }
  },
  methods: {
    pushVote(){
      if (!this.mgp.allowVote) { return; }
      this.$store.dispatch('mgp/vote', { id: this.track.id, index: this.trackIndex, voteId: this.mgp.voteId });
    }
  }
}
</script>
